import { Injectable } from '@angular/core';
import { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import { ConverterChangePasswordInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-change-password.dto';
import { ConverterFiltersInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-filters.dto';
import { ConverterFindInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-find.dto';
import { ConverterPageInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-page.dto';
import { ConverterQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-query.dto';
import { ConverterTimeZoneQueryInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-timezone-query.dto';
import { IronLogicCommandQueuePageInterface } from '@zaoblako/shared/modules/pacs/dtos/iron-logic/iron-logic-command-queue-page.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { ConverterTimezoneFormInterface } from '@zaoblako/shared/modules/pacs/dtos/converter/converter-timezone-form.dto';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConverterService extends BaseService {
  protected baseUrl = '/pacs/base/converter';

  public findManyPage(queryParams: ConverterQueryInterface): Observable<ConverterPageInterface> {
    return this.http.get<ConverterPageInterface>(`${this.baseUrl}/page`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public findAll(queryParams: ConverterFiltersInterface): Observable<ConverterFindInterface[]> {
    return this.http.get<ConverterFindInterface[]>(`${this.baseUrl}/all`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public restore(id: number): Observable<ConverterFindInterface> {
    return this.http.post<ConverterFindInterface>(`${this.baseUrl}/${id}/restore`, {});
  }

  public changeStatus(converterId: number): Observable<ConverterFindInterface> {
    return this.http.get<ConverterFindInterface>(`${this.baseUrl}/${converterId}/switch`);
  }

  public openDoor(converterId: number): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${converterId}/open-door`);
  }

  public synchronizationAll(): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/all/synchronization`);
  }

  public synchronization(id: number): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${id}/synchronization`);
  }

  public changePassword(id: number, body: ConverterChangePasswordInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/change-password`, body);
  }

  public getHistory(id: number, queryParams: PaginationQueryInterface): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public getOperationHistory(
    id: number,
    queryParams: PaginationQueryInterface
  ): Observable<IronLogicCommandQueuePageInterface> {
    return this.http.get<IronLogicCommandQueuePageInterface>(`${this.baseUrl}/${id}/operation-history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public startCardsCountSync(converterId: number): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${converterId}/start-cards-count-sync`);
  }

  public setTimeZone(id: number, body: ConverterTimezoneFormInterface): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/set-timezone`, body);
  }

  public resetTimeZone(id: number, queryParams: ConverterTimeZoneQueryInterface): Observable<void> {
    return this.http.get<void>(`${this.baseUrl}/${id}/reset-timezone`, {
      params: this.objectToHttpParams(queryParams)
    });
  }
}
